import React, { useEffect } from 'react';
import { mutate1Object } from 'screens/Warehouses/actions';
import { useSelector, useDispatch } from 'react-redux';
import { handleOnClickCreateArticle } from 'screens/Warehouses/actions';
import {
	selectCreateArticle,
	selectItemFamilies,
	selectMeasuredUnits,
	selectCoins,
} from 'screens/Warehouses/selectors';
import {
	selectSelectedOrderTargetFilter,
	selectSelectedOrderTargetFilterId,
	selectSelectedProject,
} from 'core/selectors';
import { CreateArticle } from 'screens/Warehouses/subs';
import { getCoins, getItemFamilies, getMeasuredUnits } from 'store/api/actions';
import { Alert } from 'antd';

const CreateInventoryItem = () => {
	const createArticle = useSelector(selectCreateArticle);
	const coins = useSelector(selectCoins);
	const measuredUnits = useSelector(selectMeasuredUnits);
	const itemFamilies = useSelector(selectItemFamilies);
	const orderTargetId = useSelector(selectSelectedOrderTargetFilterId);
	const selectedProject = useSelector(selectSelectedProject);
	const selectedOrderTarget = useSelector(selectSelectedOrderTargetFilter);

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getItemFamilies());
		dispatch(getMeasuredUnits());
		dispatch(getCoins());
	}, []);

	const projectLabel = selectedProject?.name || 'Proyecto no seleccionado';
	const orderTargetLabel =
		selectedOrderTarget?.name ||
		(orderTargetId
			? `Línea de negocio ${orderTargetId}`
			: 'Línea de negocio no seleccionada');

	return (
		<>
			<Alert
				type='info'
				showIcon
				message={`Este artículo se creará en: ${projectLabel} → ${orderTargetLabel}`}
			/>
			<CreateArticle
				createArticle={createArticle}
				measuredUnits={measuredUnits}
				coins={coins}
				itemFamilies={itemFamilies}
				mutate1Object={(obj1Name, keyValuePairs) =>
					dispatch(mutate1Object(obj1Name, keyValuePairs))
				}
				handleOnClickCreateArticle={() =>
					dispatch(
						handleOnClickCreateArticle({
							...createArticle,
							order_target_id: orderTargetId,
						}),
					)
				}
			/>
		</>
	);
};

export default CreateInventoryItem;
